export const getImportIconName = (iconName) => {
    const iconNameArray = iconName.split('-');
    const capitalizedIconNameArray = iconNameArray.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
    return `fa${capitalizedIconNameArray.join('')}`;
};
//# sourceMappingURL=getImportIconName.js.map